import { selectAmount, selectCartItems, selectCartStatus } from '@entities/cart';
import { useAppSelector } from '@shared/hooks';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';

export const useCheckoutData = () => {
  const items = useAppSelector(selectCartItems);
  const cartAmount = useAppSelector(selectAmount);
  const { permissions } = useModuleByCodeParam();
  const status = useAppSelector(selectCartStatus);

  const amount = () => {
    // считаем стоимость всех товаров для обычного покупателя

    let amount = 0;
    if (items && items.length) {
      for (const item of items) {
        const price = item.buyer_price;
        const count = item.count;
        amount += price * count;
      }
    }
    return amount;
  };

  const partnerAmount = () => {
    // считаем стоимость всех товаров для партнера
    let amount = 0;
    if (items && items.length) {
      for (const item of items) {
        if (item.partner_price) {
          const price = item.partner_price;
          const count = item.count;
          amount += price * count;
        }
      }
    }
    return amount;
  };

  const discount = () => {
    // рассчитываем скидку, если есть
    if (permissions.can_sell) {
      return amount() - partnerAmount();
    }

    return amount() - cartAmount;
  };

  const finalAmount = () => {
    if (permissions.can_sell) {
      return partnerAmount();
    }

    return cartAmount;
  };

  return {
    amount: amount(),
    discount: discount(),
    final: finalAmount(),
    loadingStatus: status,
  };
};
